<template>
  <router-view />
</template>


<script setup>
import { onBeforeMount } from 'vue'
import { useBreakpoints } from '@/composables/useBreakpoints'

//init breakpoints
useBreakpoints()





onBeforeMount(() => {
  //add classes to body tag before app mount
  document.body.classList.add(
    'antialiased',
    'text-slate-500',
    'bg-neutral-50',
    'overflow-auto'
  )


})


</script>

<style lang="scss"></style>
